import React, { useState } from 'react';
import { Card, Select, Progress, Row, Col, Typography, Rate } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChalkboardTeacher, faUsers, faStar, faComments } from '@fortawesome/free-solid-svg-icons';
import '../../css/JuanIS/JuanISFacultyOTE.css';

const { Option } = Select;
const { Title, Text } = Typography;

function JuanISFacultyOTE() {
  const [selectedClass, setSelectedClass] = useState('STEM-11A-OralComm');
  const [selectedQuarter, setSelectedQuarter] = useState('1');

  // Sample data - replace with actual data from your backend
  const classes = [
    { value: 'STEM-11A-OralComm', label: 'STEM-11A - Oral Communication' },
    { value: 'STEM-11B-GenMath', label: 'STEM-11B - General Mathematics' }
  ];

  const quarters = [
    { value: '1', label: '1st Quarter' },
    { value: '2', label: '2nd Quarter' },
    { value: '3', label: '3rd Quarter' },
    { value: '4', label: '4th Quarter' }
  ];

  const evaluationStats = [
    {
      icon: faChalkboardTeacher,
      title: 'Teaching Methods',
      score: 4.5,
      color: '#4a90e2'
    },
    {
      icon: faUsers,
      title: 'Student Engagement',
      score: 4.8,
      color: '#50c878'
    },
    {
      icon: faStar,
      title: 'Overall Rating',
      score: 4.6,
      color: '#FFB800'
    },
    {
      icon: faComments,
      title: 'Communication',
      score: 4.7,
      color: '#ff6b6b'
    }
  ];

  const criteriaScores = [
    { criteria: 'Knowledge of Subject Matter', score: 90 },
    { criteria: 'Teaching Strategy', score: 85 },
    { criteria: 'Class Management', score: 88 },
    { criteria: 'Student Assessment', score: 92 },
    { criteria: 'Professional Attitude', score: 95 }
  ];

  const comments = [
    "Very knowledgeable and explains concepts clearly",
    "Makes the class interesting and engaging",
    "Always available for consultation",
    "Provides helpful feedback on assignments"
  ];

  return (
    <div className="juanis-faculty-ote-container">
      <div className="juanis-faculty-ote-header">
        <Title level={2}>Online Teacher Evaluation Results</Title>
        <div className="juanis-faculty-ote-header-controls">
          <Select
            value={selectedClass}
            onChange={setSelectedClass}
            className="juanis-faculty-ote-class-select"
          >
            {classes.map(cls => (
              <Option key={cls.value} value={cls.value}>{cls.label}</Option>
            ))}
          </Select>
          <Select
            value={selectedQuarter}
            onChange={setSelectedQuarter}
            className="juanis-faculty-ote-quarter-select"
          >
            {quarters.map(quarter => (
              <Option key={quarter.value} value={quarter.value}>{quarter.label}</Option>
            ))}
          </Select>
        </div>
      </div>

      <Row gutter={[16, 16]} className="juanis-faculty-ote-stats-row">
        {evaluationStats.map((stat, index) => (
          <Col xs={24} sm={12} md={6} key={index}>
            <Card className="juanis-faculty-ote-stat-card">
              <div className="juanis-faculty-ote-stat-icon" style={{ color: stat.color }}>
                <FontAwesomeIcon icon={stat.icon} />
              </div>
              <div className="juanis-faculty-ote-stat-info">
                <h3>{stat.title}</h3>
                <Rate disabled defaultValue={stat.score} allowHalf />
                <p>{stat.score} / 5.0</p>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]} className="juanis-faculty-ote-details-row">
        <Col xs={24} md={16}>
          <Card title="Evaluation Criteria" className="juanis-faculty-ote-criteria-card">
            {criteriaScores.map((item, index) => (
              <div key={index} className="juanis-faculty-ote-criteria-item">
                <div className="juanis-faculty-ote-criteria-header">
                  <Text>{item.criteria}</Text>
                  <Text strong>{item.score}%</Text>
                </div>
                <Progress 
                  percent={item.score} 
                  showInfo={false}
                  strokeColor="#FFB800"
                  trailColor="#f0f0f0"
                />
              </div>
            ))}
          </Card>
        </Col>
        <Col xs={24} md={8}>
          <Card title="Student Comments" className="juanis-faculty-ote-comments-card">
            <div className="juanis-faculty-ote-comments-list">
              {comments.map((comment, index) => (
                <div key={index} className="juanis-faculty-ote-comment-item">
                  <FontAwesomeIcon icon={faComments} className="juanis-faculty-ote-comment-icon" />
                  <Text>{comment}</Text>
                </div>
              ))}
            </div>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default JuanISFacultyOTE;